function createDateAsUTC (date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
}

const formatDateDiffString = (dateString) => {
  // we store our date strings as UTC, so we need to convert them to local time
  const date = createDateAsUTC(new Date(dateString))
  const now = new Date()
  const diff = now - date
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor(diff / (1000 * 60 * 60))
  const minutes = Math.floor(diff / (1000 * 60))
  const seconds = Math.floor(diff / 1000)
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
  if (days > 0) {
    return `${days} day${days !== 1 ? 's' : ''} ago`
  } else if (hours > 0) {
    return `${hours} hour${hours !== 1 ? 's' : ''} ago`
  } else if (minutes > 0) {
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`
  } else if (seconds > 0) {
    return `${seconds} second${seconds !== 1 ? 's' : ''} ago`
  } else {
    return `${time}`
  }
}

export default formatDateDiffString
